<template>
    <div>
        <div class="page_cover  page_shadow">
            <div class="logoBox">
                <img :src="headerLogo" alt="">
            </div>
            <div class="header">
                <h3>学习力测评报告</h3>
                <p>Learning Power Assessment Report</p>
            </div>
            <div class="main">
                <p class="title">
                    <span>{{user.realname}}</span>
                    <span>{{user.grade}}</span>
                </p>
                <!--				<p class="date">报告时间：{{formatDate(user.updated_at)}}</p>-->
                <p class="date">报告生成时间：{{date}}</p>
            </div>
        </div>
        <div class="page_meaasge  page_shadow">
            <TopHeader :title="'报告综合信度指数'"  :headerLogo="headerLogo"></TopHeader>
            <div class="line_border_title">
                <p>报告综合信度指数</p>
                <p class="line">{{reliability}}</p>
            </div>
            <table>
                <tr><th>综合信度指数</th><td colspan="2">{{reliability.comprehensiveReliabilityIndex}}（参考值：70↑）</td></tr>
                <tr><th>作答起止时间</th><td colspan="2">{{reliability.answerStartTime}} &nbsp;—&nbsp; {{reliability.answerEndTime}}</td></tr>
                <tr><th rowspan='3'>作答时间</th><td>限时能力类测试</td><td>{{reliability.limitedTime}}分钟 （参考时间：12.7-36.1分钟）</td></tr>
                <tr><td>非限时能力类测试</td><td>{{reliability.unlimitedTime}}分钟 （参考时间：4.3-36分钟）</td></tr>
                <tr><td>量表类测试</td><td>{{reliability.questionnaireTime}}分钟 （参考时间：5.9-15.6分钟）</td></tr>
                <tr><th>作答一致性</th><td colspan="2">{{reliability.consistency}}（参考值：0.7↑）</td></tr>
                <tr><th>作答规律性</th><td colspan="2">{{reliability.regularity}}次</td></tr>
                <tr><th>作答趋中性</th><td colspan="2">{{reliability.neutrality}}</td></tr>
                <tr><th>社会称许性</th><td colspan="2">{{reliability.cehuang}}（参考值：0.7↓）</td></tr>
            </table>
            <div class="copyright_box">
                <p class="title"><span>*</span>版权说明</p>
                <p>本报告内容属于个人隐私，请注意保密。</p>
                <p>本报告必须在专业咨询师的指导下使用。</p>
                <p>本报告的所有权都受到版权保护，归北京和气聚力教育科技有限公司所有。</p>
            </div>
        </div>
        <div class="page_guide  page_shadow">
            <TopHeader :title="'阅读指南'"  :headerLogo="headerLogo"></TopHeader>
            <div class="line_border_title">
                <p>阅读指南</p>
                <p class="line"></p>
            </div>
            <div class="detail">
                <p>学习力是指为塑造个体终身学习而形成的包括个体的学习情感、态度、价值观、动力及持续发展的综合素养，不仅能激发学生的学习潜能，增强学习动机，还对学生学业成就的获得有着显著影响。</p>
                <p>本报告从学习潜力、学习效力、学习动力三方面对测试者的学习力进行测评分析，同时报告心理健康状态，旨在提升测试者的自我认知，为安排学业计划提供参照。</p>
            </div>
            <div class="img_box">
                <img src="@/assets/report2_imgs/read_guide.png" alt="">
            </div>
            <div class="detail">
                <p>本报告除学习动力和心理风险采用绝对分值外，其余测验计分均采取标准分制，均分为100分，标准差为25分，常模范围均转化为75-125分。得分低于75分为低，75-92分为较低，92-108分为中等，108-125分为较高，125分以上为高。</p>
            </div>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
export default {
    components: { TopHeader },
    props: {
        headerLogo:{},
        user: {
            type: Object
        },
        reliability: {
            type: Object
        },
        total: {
            type: Object | Array
        },
        part2Total: {
            type: Object
        },
        part3Total: {
            type: Object
        },
        part4Total: {
            type: Object
        }
    },
    data() {
        return {
            date: new Date(),

        }
    },
    computed: {
        score1() {
            if (this.part1Total) {
                return this.part1Total.percent;
            }else {
                return '';
            }

        },
        score2() {
            if (this.part2Total) {
                return this.part2Total.percent;
            }else {
                return '';
            }
        },
        score3() {
            if (this.part3Total) {
                return this.part3Total.percent;
            }else {
                return '';
            }
        },
        isJianyi() {
            let score1 = this.score1;
            let score2 = this.score2;
            let score3 = this.score3;
            let arr = [];
            if(score1&&score2&&score3) {
                if(score1==score2&&score1==score3) {
                    return false;
                }
                arr = [
                    { 'score': score1, name: '学习潜力' },
                    { 'score': score2, name: '学习动力' },
                    { 'score': score3, name: '学习效力' }
                ];
                arr.sort(function(a, b){return b.score - a.score});
                if(arr[1].score == arr[2].score) {
                    return arr[1].name + '、' + arr[2].name
                }else {
                    return arr[2].name
                }
            }else {
                return false;
            }
        }
    },
    watch: {
    },
    created() {
        let date = new Date();
        // let year = dates.getFullYear();
        // let month = dates.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        // let date = dates.getDate(); //获取当前日(1-31)

        let YY = date.getFullYear() + '-';
        let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        // this.date = year + '-' + month + '-' + date;
        this.date = YY + MM + DD;
    },
    methods: {
        getJianyi() {
            let total1 = this.part1Total;
            let total2 = this.part1Tota2;
            let total3 = this.part1Tota3;
            let arr = [];
            if(total1&&total2&&total3) {

            }
        },
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            return YY + MM + DD +" "+hh + mm + ss;
        }
    },
    mounted() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_cover {
    background: url(~@/assets/report2_imgs/page_cover.png);
    background-size: 900px 1300px;
    position: relative;
    .logoBox {
        position: absolute;
        width: 140px;
        height: 70px;
        top: 40px;
        left: 50px;

    }
    .header {
        padding-top: 90px;
        margin-bottom: 700px;
        text-align: center;
        h3 {
            line-height: 100px;
            font-size: 80px;
            color: #333;
            margin-bottom: 20px;
        }
        p {
            font-size: 26px;
            line-height: 40px;
            display: inline-block;
            width: 566px;
            text-align: center;
            border-radius: 20px;
            color: #fff;
            background-color: #F6A724;
        }
    }
    .main {
        //padding-top: 550px;
        text-align: center;
        color: #fff;
        .title {
            font-size: 24px;
            margin-bottom: 20px;
            span {
                margin-right: 20px;
            }
        }
        .date {
            font-size: 24px;
        }
    }
}
.page_meaasge {
    table {
        margin-bottom: 50px;
        tr {
            line-height: 45px;
            th {
                width: 130px;
                text-align: center;
                border: 1px solid #DFDEDE;
                font-size: 14px;
                font-weight: bold;
                background: #F9F8F8;
            }
            td {
                border: 1px solid #DFDEDE;
                font-size: 12px;
                padding-left: 10px;
            }
        }

    }
    .copyright_box {
        p {
            font-size: 15px;
            color: #767474;
            line-height: 35px;
        }
        .title {
            span {
                color:#F20606;
            }
            font-size: 16px;
            font-weight:bold;
            color: #333;
        }
    }
}
.page_guide {
    .img_box {
        padding-top: 40px;
        padding-bottom: 60px;
        img {
            display: block;
            margin: 0 auto;
        }
    }
    .detail {
        p {
            font-size: 15px;
            line-height: 32px;
            text-indent: 2em;
            margin-bottom: 10px;
        }
    }

}
</style>
